import React, { useEffect, useState } from 'react';
import seguridadProvider from '../../../services/seguridadProvider';
import { Anchor, Button, Col, List, message, Modal, Row, Image } from 'antd';
import { irLoginEleccion } from '../../../utils/navegar-login-eleccion';
import jwt_decode from 'jwt-decode';
import './eleccion.css';
import { FormOutlined } from '@ant-design/icons';
import { history } from '../../../redux/store';
import { useFetchPageData } from '../../../hooks/usePage';
import { IEleccion, Usuario } from '../../../interfaces/elecciones/eleccion';
import { rejects } from 'assert';
import eleccionesProvider from '../../../services/eleccionesProvider';
import { IResponse } from '../../../interfaces/response';
import Countdown from 'antd/es/statistic/Countdown';
import administracionProvider from '../../../services/administracionProvider';
import _ from 'lodash';

const moment = require('moment');
const uniqid = require('uniqid');

const { confirm } = Modal;

const EleccionHostigamiento = () => {
  const [postulantes, setpostulantes] = useState<Usuario[]>();
  const [postulanteselect, setpostulanteselect] = useState<Usuario>();
  const [guardando, setguardando] = useState(false);
  const [expiracion, setexpiracion] = useState<Date>();
  const [imagen, setimagen] = useState<string>();

  const [data, setdata] = useState([]);
  const [mujeres, setmujeres] = useState([]);
  const [hombres, sethombres] = useState([]);
  const [electos, setelectos] = useState([]);

  const [expiraciontoken, setexpiraciontoken] = useState(moment());
  const [eleccion] = useFetchPageData<IEleccion>('/elecciones/ObtenerEleccionVIgente', null);

  useEffect(() => {
    if (localStorage.getItem('token') === null) {
      irLoginEleccion();
      return;
    }
    const token: any = jwt_decode(localStorage.getItem('token'));
    if (eleccion != null) {
      setexpiraciontoken(moment.unix(token.exp));
      setexpiracion(eleccion.eleccion.horaFin);
      postulantesProfile(eleccion.postulantes);
    }
  }, [eleccion]);

  useEffect(() => {
    validarSesion()
      .then((res) => {
        console.info('respuesta:', res);
      })
      .catch((err) => {
        console.info('err', err);
      });
    return () => {
      console.info('limpiar...');
    };
  }, []);
  const validarSesion = async () => {
    return await seguridadProvider.validarEstadoEleccion().catch((err) => {
      if (err.request.status === 401) {
        message.warning('No esta permitido!');
        irLoginEleccion();
      }
    });
  };

  async function postulantesProfile(postulantes) {
    const size = 3;

    const postulantesConImagen = [];
    for (const p of postulantes) {
      if (p.adjuntoId > 0) {
        const response: any = await administracionProvider.obtenerAdjunto(p.adjuntoId);
        p.adjunto = response;
      } else {
        p.adjunto = '';
      }
      postulantesConImagen.push(p);
    }

    postulantes = _.orderBy(postulantesConImagen, ['orden'], ['asc']);
    const m = postulantes.slice(0, size);
    const h = postulantes.slice(size, postulantes.length);

    setmujeres(m);
    sethombres(h);
    setpostulantes(_.orderBy(postulantesConImagen, ['orden'], ['asc']));
    setdata(m);
  }

  const toBase64 = (blob) =>
    new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  const elegirCandidato = (item) => {
    setpostulanteselect(item);
    const temp = postulantes.map((x) => {
      x.selected = false;
      if (x === item) {
        x.selected = !x.selected;
      }
      return x;
    });
    setpostulantes(temp);
  };

  const onVotar = () => {
    confirm({
      title: `HAZ ELEGIDO VOTAR POR:`,
      icon: <FormOutlined style={{ color: '#156185' }} />,
      content: (
        <div>
          <ul>
            <li>
              {electos[0].nombres} {electos[0].apellidos}
            </li>
            <li>
              {electos[1].nombres} {electos[1].apellidos}
            </li>
          </ul>
          <p>Presiona SI para confirmar tu voto o NO para reiniciar.</p>
        </div>
      ),
      maskStyle: { backgroundColor: 'rgb(0 0 0 / 58%)' },
      okText: 'SI',
      cancelText: 'NO',
      okButtonProps: { style: { backgroundColor: '#156185' } },
      cancelButtonProps: { style: { backgroundColor: '#d9d9d9' } },
      onOk() {
        return new Promise((resolve, reject) => {
          setguardando(true);
          const key = uniqid();
          electos.map((x) => (x.uniqId = key));
          eleccionesProvider
            .guardarVotos(electos)
            .then((res: any) => {
              //TODO VALIDAR
              if (res.succeeded) {
                message.success(res.message);
                history.push({ pathname: '/static/resultado-voto', state: key });
              } else {
                message.warning(res.message);
              }
              setguardando(false);
              resolve('');
            })
            .catch((err) => {
              reject();
            });
        }).catch(() => rejects);
      },
      onCancel() {
        window.location.reload();
      }
    });
  };

  const finalizaConteo = () => {
    message.info('Finalizo su sesión');
    irLoginEleccion();
  };

  useEffect(() => {
    console.log(electos);
    if (electos.length == 2) {
      onVotar();
    }
  }, [electos]);

  const siguiente = () => {
    if (electos.length >= 2) {
      onVotar();
      return;
    }
    const electo = _.find(data, { selected: true });
    setelectos([...electos, electo]);
    if (electos.length >= 1) {
      return;
    }
    setdata(hombres);
  };

  return (
    <>
      <div className='row'>
        <div className='col-md-2'>
          <Anchor>
            <p style={{ marginLeft: '10px' }}>
              {eleccion != null ? (
                <Countdown
                  title='Tu tiempo para votar expira en'
                  value={expiraciontoken}
                  onFinish={finalizaConteo}
                />
              ) : null}
            </p>
            <p style={{ marginLeft: '10px' }}>
              {eleccion != null ? (
                <Countdown
                  title='Tiempo restante para finalizar la elección'
                  value={moment(eleccion.eleccion.horaFinLocal)}
                  onFinish={finalizaConteo}
                />
              ) : null}
            </p>
          </Anchor>
        </div>
        <div className='col-md-10'>
          <h4 className={'text-center'}>
            Elección Representantes Trabajadores Comité de Intervención frente al Hostigamiento
            Sexual
          </h4>
          <br />
          <h5>Postulante {electos.length == 1 ? 'masculino' : 'femenino'}</h5>
          <p>Seleccione solo una de las siguientes opciones:</p>
          {eleccion !== null ? (
            <List
              grid={{
                gutter: 16,
                xs: 1,
                sm: 2,
                md: 4,
                lg: 4,
                xl: 6,
                xxl: 3
              }}
              dataSource={data}
              renderItem={(i) => (
                <List.Item
                  key={i.title}
                  extra={
                    <>
                      <div className={`container ${i.selected ? 'selected' : ''}`}>
                        <Image
                          className={'image'}
                          preview={false}
                          src={i.adjunto != '' ? i.adjunto : 'error'}
                          fallback='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=='
                        />
                        <div className='middle'>
                          <div className='text-button' onClick={() => elegirCandidato(i)}>
                            {i.selected ? 'Seleccionado' : 'Seleccionar'}
                          </div>
                        </div>
                      </div>
                      <Row justify={'center'}>
                        <Col>
                          <strong>{i.title}</strong>
                        </Col>
                      </Row>
                    </>
                  }
                ></List.Item>
              )}
            />
          ) : null}
          {postulantes != undefined ? (
            <Button
              onClick={siguiente}
              disabled={data.filter((e) => e.selected).length === 0}
              style={{ backgroundColor: '#156185' }}
              block
            >
              {electos.length >= 1 ? 'Votar' : 'Siguiente'}
            </Button>
          ) : null}
        </div>
      </div>
    </>
  );
};
export default EleccionHostigamiento;
